import { render } from "./UserPostListPage.vue?vue&type=template&id=6382769e&ts=true"
import script from "./UserPostListPage.vue?vue&type=script&lang=ts"
export * from "./UserPostListPage.vue?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/flowerdiy/flowerdiy/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__